import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">
          影视分类
        </h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/40 hover:border-primary-500/30 transition-all duration-300 p-5 md:p-6 flex flex-col items-center gap-3 cursor-pointer"
          >
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 group-hover:scale-110 transition-all duration-300">
              <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
            </div>
            <span className="text-sm md:text-base font-medium text-foreground-200 group-hover:text-foreground-100 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
            <div className="absolute inset-0 bg-gradient-to-t from-primary-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
          </Link>
        ))}
      </div>
    </section>
  );
}